<script setup lang="ts">
import { UITextMdMedium } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { EyeIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag } from '@gohighlevel/ghl-ui'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium class="text-base font-semibold">
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        <template v-if="data?.metaData?.email"
          >({{ data.metaData.email }})</template
        >
      </span>
      <span class="text-gray-800" v-else>{{ data.metaData.email }}</span>
      <span class="text-gray-500 ml-1">
        {{ t('proposalsList.eventLogs.viewedTitle') }}
      </span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-3">
    <p class="text-md text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="info" size="medium" class="text-[8px] viewed-event">
      <template #icon> <EyeIcon class="w-4 h-4 eye-icon" /></template>
      {{ t('proposalsList.eventLogs.viewed') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.viewed-event {
  --n-text-color: rgb(126 34 206) !important;
  --n-color: rgb(250 245 255) !important;
  --n-border: 0px !important;
}
.eye-icon {
  color: rgb(168 85 247) !important;
}
</style>
